import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { IsObjectNotEmpty } from "../../common/utils";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  firmIDAndName: null,
  billingDetails: [],
  CCPaymentResponse: null,
  PayCheckedInvoiceResponse: null,
  ProfileLawyer: null,
  ManageBillingLawyer: null,
  allBillingDetails: [],
};

// our slice
const manageBillingSlice = createSlice({
  name: "manageBilling",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setFirmIDAndName: (state, { payload }) => {
      state.firmIDAndName = payload;
    },
    setBillingDetails: (state, { payload }) => {
      state.billingDetails = payload;
    },
    setAllBillingDetails: (state, { payload }) => {
      state.allBillingDetails = payload;
    },
    setCCPaymentResponse: (state, { payload }) => {
      state.CCPaymentResponse = payload;
    },
    setPayCheckedInvoiceResponse: (state, { payload }) => {
      state.PayCheckedInvoiceResponse = payload;
    },
    setProfileLawyer: (state, { payload }) => {
      state.ProfileLawyer = payload;
    },
    setManageBillingLawyer: (state, { payload }) => {
      state.ManageBillingLawyer = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setFirmIDAndName,
  setBillingDetails,
  setCCPaymentResponse,
  setProfileLawyer,
  setManageBillingLawyer,
  setPayCheckedInvoiceResponse,
  setAllBillingDetails
} = manageBillingSlice.actions;

export const manageBillingSelector = (state) => state.manageBilling;

// export the default reducer
export default manageBillingSlice.reducer;

export const GetFirmByUserID = (userid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      UserID: userid,
    };

    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("Lawfirm/GetFirmByUserID", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      if (results.data.responseObject.firmID > 0)
        dispatch(setFirmIDAndName(results.data.responseObject));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const SavePaymentInformation =
  (request, lawyerid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = {
        UserID: request.UserID,
        RequestObject: request,
      };
      const results = await http
        .post("Billing/SavePaymentInformation", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(GetBillingDetails(request?.FirmID, lawyerid, request?.UserID));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const SavePaymentInformationEFT =
  (request, lawyerid, userid, firmid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = {
        UserID: userid,
        RequestObject: request,
      };
      const results = await http
        .post("Billing/SavePaymentInformationEFT", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(GetBillingDetails(firmid, lawyerid, userid));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

// export const GetPaymentInformation =
//   (userid, firmid, dealtype, billing) => async (dispatch) => {
//     try {
//       dispatch(setLoading());
//       let request = {
//         LawyerID: billing === "firm" ? null : userid,
//         FirmID: billing === "firm" ? firmid : null,
//         DealType: dealtype,
//       };

//       let req = { UserID: userid, RequestObject: request };
//       const results = await http
//         .post("Billing/GetPaymentInformation", req)
//         .then((result) => {
//           return result;
//         });

//       if (results.data.responseCode == 0) {
//         dispatch(setSuccess());
//       }
//     } catch (error) {
//       const errorMessage =
//         error.response && error.response.data
//           ? error.response.data.title
//           : error.message;
//       dispatch(setError(errorMessage));
//     }
//   };

export const SavePrefferedBilling = (request) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      UserID: request.UserID,
      RequestObject: request,
    };
    const results = await http
      .post("Billing/SavePreferredBilling", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(GetFirmByUserID(request.UserID));
      dispatch(GetBillingDetails(request?.FirmID, request?.UserID, request?.UserID))
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

// export const GetBillingDetails =
//   (firmid, lawyerid, userid, uniqueLawyerCount) => async (dispatch, getState) => {
//     try {
//       dispatch(setLoading());
//       let request = {
//         FirmID: firmid,
//         LawyerID: IsObjectNotEmpty(lawyerid) ? lawyerid : userid,
//       };

//       let req = { UserID: userid, RequestObject: request };
//       const results = await http
//         .post("Billing/GetBillingDetailFromFirmID", req)
//         .then((result) => {
//           return result;
//         });

//       if (results.data.responseCode == 0) {
//         const state = getState();
//         dispatch(setSuccess());
//         dispatch(
//           setBillingDetails(
//             state.manageBilling.billingDetails?.length > 0
//               ? [
//                   ...state.manageBilling.billingDetails,
//                   results.data.responseObject,
//                 ]
//               : results.data.responseObject
//           )
//         );
//       }
//     } catch (error) {
//       const errorMessage =
//         error.response && error.response.data
//           ? error.response.data.title
//           : error.message;
//       dispatch(setError(errorMessage));
//     }
//   };

export const GetBillingDetails =
  (firmid, lawyerid, userid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        FirmID: firmid,
        LawyerID: IsObjectNotEmpty(lawyerid) ? lawyerid : userid,
      };

      let req = { UserID: userid, RequestObject: request };
      const result = await http.post("Billing/GetBillingDetailFromFirmID", req);
      if (result.data.responseCode === 0) {
        dispatch(setSuccess());
        dispatch(setBillingDetails(result.data.responseObject));
        return result.data.responseObject;
      } else {
        throw new Error("Invalid response");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.title || error.message;
      dispatch(setError(errorMessage));
      return null;
    }
  };

export const GetAllBillingDetails =
  (firmId, selectedOutstandingInvoices, userId) => async (dispatch) => {
    try {
      dispatch(setLoading());

      // Step 1: Get unique lawyerIDs
      const lawyerMap = new Map();
      selectedOutstandingInvoices.forEach((item) => {
        const lawyerID = item?.original?.lawyerID;
        if (lawyerID && !lawyerMap.has(lawyerID)) {
          lawyerMap.set(lawyerID, item);
        }
      });

      // Step 2: Make all billing detail requests in parallel
      const promises = Array.from(lawyerMap.entries()).map(([lawyerID, item]) =>
        dispatch(GetBillingDetails(firmId, lawyerID, userId))
          .then((result) => ({ lawyerID, result }))
          .catch(() => null)
      );

      const results = await Promise.all(promises);

      // Step 3: Filter and map results
      const billingDetailsByLawyer = {};
      results.forEach((entry) => {
        if (entry?.result) {
          billingDetailsByLawyer[entry.lawyerID] = entry.result;
        }
      });

      // Step 4: Dispatch
      if (Object.keys(billingDetailsByLawyer).length > 0) {
        dispatch(setSuccess());
        dispatch(setAllBillingDetails(billingDetailsByLawyer));
      } else {
        dispatch(setError("No billing details fetched."));
      }
    } catch (err) {
      dispatch(
        setError("Something went wrong while fetching billing details.")
      );
    }
  };

export const DeletePaymentByID =
  (billingid, lawyerid, firmid, userid, preferredBillingType) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading());
 
      const state = getState();
      const billingDetails = state.manageBilling.billingDetails;
 
      let request = {
        ID: billingid,
        FirmID: firmid,
        UserID: lawyerid,
      };
 
      let req = { UserID: userid, RequestObject: request };
 
      const results = await http
        .post("Billing/DeletePaymentInformationByID", req)
        .then((result) => result);
 
      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
 
        // CHECK if deleted payment is used in paymentMethodSetUp
        const affectedDealTypes =
          billingDetails?.paymentMethodSetUp?.filter(
            (x) => parseInt(x.billingID) === parseInt(billingid)
          ) || [];
 
        if (affectedDealTypes.length > 0) {
          let PaymentMethodSetUpList = affectedDealTypes.map((item) => ({
            FirmID: firmid,
            LawyerID: lawyerid,
            ID: item.id,
            BillingID: 999, // Cheque fallback
            BillingTypeID: 0,
            DealType: item.dealType,
            PaymentFrequencyID: 0,
            UserID: userid,
            UserName: "",
            BillingType: "",
            PaymentMethod: "",
            BillingFrequency: "",
            PaymentFrequency: "",
            StatementFrequency: "",
            PrefferredBillingType: preferredBillingType,
          }));
 
          let finalRequest = {
            PaymentMethodSetUpList,
          };
 
          await dispatch(
            SavePaymentMethodSetUps(finalRequest, userid, lawyerid, firmid)
          );
        }
 
        dispatch(GetBillingDetails(firmid, lawyerid, userid));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
 
      dispatch(setError(errorMessage));
    }
  };

export const SavePaymentMethodSetUps =
  (request, userid, lawyerid, firmid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = {
        UserID: userid,
        RequestObject: request,
      };
      const results = await http
        .post("Billing/SavePaymentMethodSetUpInformation", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(GetBillingDetails(firmid, lawyerid, userid));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const ProcessCCPayment =
  (request, userid, { toast }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let req = {
          UserID: userid,
          RequestObject: request,
        };
        const results = await http
          .post("Billing/ProcessCCPayment", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          dispatch(setSuccess());
          dispatch(setCCPaymentResponse(results.data.responseObject));
          // toast(
          //   "Response - " +
          //   results?.data?.responseObject?.responseResult +
          //   "." +
          //   "Payment Transaction ID - " +
          //   results?.data?.responseObject?.transactionID,
          //   {
          //     type: results?.data?.responseObject?.isSuccess
          //       ? "success"
          //       : "error",
          //   }
          // );
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.title
            : error.message;
        dispatch(setError(errorMessage));
        toast("Something went wrong!", { type: "error" });
      }
    };
export const ProcessCCPaymentForPayCheckedInvoice =
  (request, userid, { toast }) =>
    async (dispatch, getState) => {
      try {
        dispatch(setLoading());
        let req = {
          UserID: userid,
          RequestObject: request,
        };
        const results = await http
          .post("Billing/ProcessCCPaymentForPayCheckedInvoice", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          const state = getState();
          const PayCheckedInvoiceResponse =
            state?.manageBilling?.PayCheckedInvoiceResponse;
          dispatch(setSuccess());
          dispatch(
            setPayCheckedInvoiceResponse(
              PayCheckedInvoiceResponse?.length > 0
                ? [
                  ...PayCheckedInvoiceResponse,
                  {
                    InvoiceID: request?.invoiceIds,
                    isSuccess: results.data.responseObject.isSuccess,
                    transactionID: results.data.responseObject.transactionID,
                  },
                ]
                : [
                  {
                    InvoiceID: request?.invoiceIds,
                    isSuccess: results.data.responseObject.isSuccess,
                    transactionID: results.data.responseObject.transactionID,
                  },
                ]
            )
          );
          // toast("Payment " + results?.data?.responseObject?.responseResult+"." + "Transaction ID - "+results?.data?.responseObject?.transactionID, {
          //   type: results?.data?.responseObject?.isSuccess ? "success" : "error",
          // });
          // results?.data?.responseObject?.isSuccess
          //   ? toast.success(
          //       "Payment " +
          //         results?.data?.responseObject?.responseResult +
          //         "." +
          //         "Transaction ID - " +
          //         results?.data?.responseObject?.transactionID
          //     )
          //   : toast.error(
          //       "Payment " +
          //         results?.data?.responseObject?.responseResult +
          //         "." +
          //         "Transaction ID - " +
          //         results?.data?.responseObject?.transactionID
          //     );

          // console.log("FINAL TRANSACTION RESULTS: ", PayCheckedInvoiceResponse);
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.title
            : error.message;
        dispatch(setError(errorMessage));
        toast("Something went wrong!", { type: "error" });
      }
    };
